import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';
import {GruposPaginas} from '../../configs/iluminação'

const RooftopPagina = () => {
  return (
    <div className="Rooftop-container">
      <GroupLightComponent
        groupIds={GruposPaginas[3]}
        pageTitle="Luzes do Rooftop" 
      />
    </div>
  );
};

export default RooftopPagina;